import {
  AutoComplete,
  ISelectType,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import MainApi from "../../../services/mainApi.service";
import { IGeneric } from "../../../models/generics";
import { useParams } from "react-router-dom";
import { TWhatsappTemplateForm } from "./whatsappTemplateSchema";

const GENERICS_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Generic/";
const genericService = new MainApi<IGeneric>(GENERICS_ROUTE);

const translationPath = "chatBot.page.templates.whatsapp_template.";

export const HeaderType = memo(() => {
  const { id } = useParams();

  const { t } = useTranslation();

  const { setValue } = useFormContext<TWhatsappTemplateForm>();

  const { sendRequest } = useFetch(genericService.list);

  const [headerTypes, setHeaderTypes] = useState<ISelectType[]>([]);

  const handleChangeHeaderType = () => {
    if (id) return;
    setValue("fileFixed", false);
  };

  const fetchHeaderTypes = useCallback(async () => {
    const { data, success } = await sendRequest({
      identifier: "TicketAutomationTemplateHeaderFileType",
    });
    if (data && success) {
      setHeaderTypes(data);
    }
  }, [sendRequest]);

  useEffect(() => {
    fetchHeaderTypes();
  }, [fetchHeaderTypes]);

  useEffect(() => {
    if (!id) {
      setValue(
        "headerType",
        headerTypes.find((h) => h.code === "1"),
      );
    }
  }, [id, headerTypes, setValue]);

  return (
    <AutoComplete
      name="headerType"
      label={t(translationPath + "header_type")}
      getOptionLabel={(option) => option.name}
      options={headerTypes}
      size="small"
      fullWidth
      clearIcon={false}
      onValueChange={handleChangeHeaderType}
    />
  );
});
